import React from "react";

export default function TabsHeader({ setSelectedTab, selectedTab }) {
  return (
    <>
      <li className="react-tabs__tab">
        <button
          className={
            selectedTab === 0
              ? "site_btn blank react-tabs__tab--selected"
              : "site_btn blank"
          }
          type="button"
          onClick={() => setSelectedTab(0)}
        >
          Property Type
        </button>
      </li>
      <li className="react-tabs__tab">
        <button
          className={
            selectedTab === 1
              ? "site_btn blank react-tabs__tab--selected"
              : "site_btn blank"
          }
          type="button"
          onClick={() => setSelectedTab(1)}
        >
          Building & Lot
        </button>
      </li>
      <li className="react-tabs__tab">
        <button
          className={
            selectedTab === 2
              ? "site_btn blank react-tabs__tab--selected"
              : "site_btn blank"
          }
          type="button"
          onClick={() => setSelectedTab(2)}
        >
          Owner
        </button>
      </li>
      <li className="react-tabs__tab">
        <button
          className={
            selectedTab === 3
              ? "site_btn blank react-tabs__tab--selected"
              : "site_btn blank"
          }
          type="button"
          onClick={() => setSelectedTab(3)}
        >
          Sales
        </button>
      </li>
      <li className="react-tabs__tab">
        <button
          className={
            selectedTab === 4
              ? "site_btn blank react-tabs__tab--selected"
              : "site_btn blank"
          }
          type="button"
          onClick={() => setSelectedTab(4)}
        >
          Debt
        </button>
      </li>
      <li className="react-tabs__tab">
        <button
          className={
            selectedTab === 5
              ? "site_btn blank react-tabs__tab--selected"
              : "site_btn blank"
          }
          type="button"
          onClick={() => setSelectedTab(5)}
        >
          Tax
        </button>
      </li>
      <li className="react-tabs__tab">
        <button
          className={
            selectedTab === 6
              ? "site_btn blank react-tabs__tab--selected"
              : "site_btn blank"
          }
          type="button"
          onClick={() => setSelectedTab(6)}
        >
          My Properties
        </button>
      </li>
    </>
  );
}
